export default {
	title: 'Cenários',
	subtitle: 'Liste todos os cenários possíveis que você avaliará',
	no_description: 'Sem descrição',

	context_worse: 'Negativo',
	context_best: 'Positivo',

	tabs: {
		list: 'Lista',
		details: 'Detalhes',
		visualization: 'Visualização',
		alt_title: 'Síntese'
	}
};
